// extracted by mini-css-extract-plugin
export default {"Splitter":"clpm_Splitter__glgMz","RightPanel":"clpm_RightPanel__sz9v7","Toolbar":"clpm_Toolbar__nBaYm","NoPhoto":"clpm_NoPhoto__Y9h3d"};